import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    latestRequests: {},
    successData: [],
    failedData: [],
    timeWindow: 60
};
const requestsSlice = createSlice({
    name: "requests",
    initialState,
    reducers: {
        setLatestRequests (state, action) {
            state.latestRequests = action.payload;
        },
        setTimeWindow (state, action) {
            state.timeWindow = action.payload;
        },
        setHistoricalData (state, action) {
            const { key, data } = action.payload;
            state[key] = data;
        },
        addRequestsDataPoint (state) {
            const { successful_reqs, failed_reqs } = state.latestRequests;
            const now = Date.now();
            const oldestPoint = now - state.timeWindow * 60 * 1000;
            const updateData = (arr, val)=>{
                const filtered = arr.filter((d)=>d.x >= oldestPoint);
                if (val != null) {
                    return [
                        ...filtered,
                        {
                            x: now,
                            y: val
                        }
                    ];
                } else {
                    return filtered;
                }
            };
            state.successData = updateData(state.successData, successful_reqs);
            state.failedData = updateData(state.failedData, failed_reqs);
        }
    }
});
export const { setLatestRequests, setTimeWindow, setHistoricalData, addRequestsDataPoint } = requestsSlice.actions;
export default requestsSlice.reducer;
